/**
 * Official brand colors for social media icons.
 * Hex values align with @icons-pack/react-simple-icons defaults and
 * each platform's brand guidelines. Use the `color` prop on Icon components
 * for reliable fill rendering. Light-tint bg/hover avoid conflict on dark UI.
 */
export const SOCIAL_COLORS = {
  whatsapp: {
    icon: "#25D366",
    bg: "rgba(37, 211, 102, 0.08)",
    bgHover: "rgba(37, 211, 102, 0.12)",
    border: "rgba(37, 211, 102, 0.4)",
  },
  /** Use var(--header-fg) or var(--muted-foreground) for consistency; no single brand color. */
  instagram: {
    icon: "var(--muted-foreground)",
    bg: "transparent",
    bgHover: "transparent",
    border: "transparent",
  },
  wechat: {
    icon: "#07C160",
    bg: "rgba(7, 193, 96, 0.08)",
    bgHover: "rgba(7, 193, 96, 0.12)",
    border: "rgba(7, 193, 96, 0.4)",
  },
  xiaohongshu: {
    icon: "#FF2442",
    bg: "rgba(255, 36, 66, 0.08)",
    bgHover: "rgba(255, 36, 66, 0.12)",
    border: "rgba(255, 36, 66, 0.4)",
  },
  facebook: {
    icon: "#0866FF",
    bg: "rgba(8, 102, 255, 0.08)",
    bgHover: "rgba(8, 102, 255, 0.12)",
    border: "rgba(8, 102, 255, 0.4)",
  },
} as const;
